import { Component, Inject, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-notification-message-popup',
    templateUrl: './notification-message-popup.component.html',
    styleUrls: ['./notification-message-popup.component.sass'],
    standalone: false
})

export class NotificationMessagePopupComponent implements AfterViewInit {
  safeMessage: SafeHtml;

  constructor(
    private dialogRef: MatDialogRef<NotificationMessagePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, isHtml?: boolean },
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef) {
    this.safeMessage = data?.isHtml
      ? this.sanitizer.bypassSecurityTrustHtml(data.message)
      : data?.message ?? '';
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
